// Auth-API-Wrapper. Spricht den V3 Hono-Worker an (`/auth/*`).
// V1-Pendant: `authFetch`, `fetchProfile`, `updateProfile` aus useAuth.js.

import { apiFetch } from './api';
import type { AuthSession, UserProfile, UserProfilePatch } from '@/types/auth';

export interface SignInInput {
  email: string;
  password: string;
}

export interface SignUpInput {
  email: string;
  password: string;
  nickname: string;
  /** V1: `startTrial` triggert 7-Tage-Trial direkt nach Signup. */
  trial?: boolean;
}

export interface RefreshInput {
  refresh_token: string;
}

export async function signIn(input: SignInInput): Promise<AuthSession> {
  return apiFetch<AuthSession>('/auth/signin', { method: 'POST', json: input });
}

export async function signUp(input: SignUpInput): Promise<{ ok: true }> {
  return apiFetch<{ ok: true }>('/auth/signup', { method: 'POST', json: input });
}

export async function refreshSession(input: RefreshInput): Promise<AuthSession> {
  return apiFetch<AuthSession>('/auth/refresh', { method: 'POST', json: input });
}

export async function recoverPassword(email: string): Promise<{ ok: true }> {
  return apiFetch<{ ok: true }>('/auth/recover', { method: 'POST', json: { email } });
}

export async function fetchProfile(accessToken: string): Promise<UserProfile | null> {
  try {
    return await apiFetch<UserProfile>('/auth/profile', { accessToken });
  } catch {
    // V1 schluckt 4xx/5xx beim Profil-Laden und gibt null zurück. Erhalten.
    return null;
  }
}

export async function updateProfile(
  accessToken: string,
  patch: UserProfilePatch,
): Promise<UserProfile> {
  return apiFetch<UserProfile>('/auth/profile', {
    method: 'PATCH',
    accessToken,
    json: patch,
  });
}
